import { graphql } from 'relay-runtime';

export const getStudentsCompletedDiagnosticInfo = graphql`
  query DiagnosticsCompletedStudentsQuery($classIds: [ID!]) {
    allStudents(
      filter: { classIds: $classIds, onlyWithOutstandingDiagnostic: null, onlyWithResetDiagnostic: true }
      first: 100
    ) {
      nodes {
        id
        firstName
        lastName
        publicUserId
      }
    }
  }
`;
export const getStudentsNotCompletedDiagnosticInfo = graphql`
  query DiagnosticsNotCompletedStudentsQuery($classIds: [ID!]) {
    allStudents(
      filter: { classIds: $classIds, onlyWithOutstandingDiagnostic: true, onlyWithResetDiagnostic: null }
      first: 100
    ) {
      nodes {
        id
        firstName
        lastName
        publicUserId
      }
    }
  }
`;

export const getStudentsDiganosticReportTableInfo = graphql`
  query DiagnosticsGetStudentsTableQuery($input: ClassDiagnosticReportFilterInput!) {
    classDiagnosticReport(filter: $input) {
      demonstratedSkills
      diagnosticCompleted
      diagnosticDate
      projectedStatusThreeSkills
      projectedStatusTwoSkills
      roadmapSkills
      lastDiagnosticId
      retakeAssigned
      student {
        id
        fullName
        publicUserId
        firstName
        lastName
      }
    }
  }
`;

export const getSkillsDiagnosticReport = graphql`
  query DiagnosticsAllSkillsQuery(
    $filter: AllSkillsFilterInput!
    $order: [SkillSortInput!]
    $targetGroupsIds: [ID!]
    $first: Int = 100
    $after: String
  ) {
    allSkills(filter: $filter, order: $order, first: $first, after: $after) {
      nodes {
        id
        code
        name
        targetSkills(filter: { targetGroupIds: $targetGroupsIds, isActive: ACTIVE }) {
          id
          target {
            id
            name
            summary
            targetGroup {
              id
              name
            }
          }
          targetSkillType {
            id
            name
          }
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const getSkillReportSubstate = graphql`
  query DiagnosticsSkillSubStateReportQuery($filter: StudentsSkillSubStateReportInput!, $skip: Boolean = false) {
    studentsSkillSubStateReport(filter: $filter) @skip(if: $skip) {
      skill {
        id
      }
      usersBySkillResults {
        value {
          id
          firstName
          lastName
          publicUserId
        }
        key
      }
    }
  }
`;

export const getDiagnosticStatusByClassReport = graphql`
  query DiagnosticsStatusByClassReportQuery($filter: ClassDiagnosticStatusReportFilterInput!) {
    classDiagnosticStatusReport(filter: $filter) {
      diagnosticStatus
      questionsAnswered
      totalActiveTime
      student {
        id
        lastName
        firstName
        publicUserId
        diagnostics {
          id
          retakeAssigned
          sessionStartedOn
        }
        studentTargetGroups {
          id
          isCurrent
          targetGroup {
            id
          }
        }
      }
    }
  }
`;

export const getDiagnosticStatusByTargetGroupReport = graphql`
  query DiagnosticsStatusByTargetGroupReportQuery($filter: TargetGroupDiagnosticStatusReportFilterInput!) {
    targetGroupDiagnosticStatusReport(filter: $filter) {
      diagnosticStatus
      questionsAnswered
      totalActiveTime
      student {
        id
        lastName
        firstName
        publicUserId
        diagnostics {
          id
          retakeAssigned
          sessionStartedOn
        }
        studentTargetGroups {
          id
          isCurrent
          targetGroup {
            id
          }
        }
      }
    }
  }
`;

export const getDemonstratedSkillsByClasses = graphql`
  query DiagnosticsDemonstratedSkillsByClassesQuery($filter: StudentSkillProgressReportFilterInput!) {
    studentSkillProgressReport(filter: $filter) {
      skillIdsBySkillResults {
        key
        value
      }
      student {
        id
      }
    }
  }
`;

export const getDemonstratedSkillsByStudent = graphql`
  query DiagnosticsDemonstratedSkillsQuery($filter: StudentsDemonstratedSkillsReportFilterInput!) {
    studentsDemonstratedSkillsReport(filter: $filter) {
      demonstratedSkills
      studentId
    }
  }
`;
